import React from 'react';
import { Box, Typography, Link, Paper, Divider, styled } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { YellowBoxBottom } from './Home';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '3rem',
  textAlign: 'center',
  backgroundColor: theme.palette.mode === 'dark' ? '#2a2a2a' : '#f7f7f7',
  color: '#909090',
}));

const ContactSection = () => {
  return (
    <Box>
      {/* Heading */}
      <Typography variant="h2" gutterBottom>
        Let's Connect
      </Typography>
      <Typography variant="homePageBody" paragraph>
        Have questions, feedback, or partnership ideas? We're here to listen.
        Whether you're curious about our AI technology, want to collaborate, or
        just want to say hello we'd love to hear from you. <br /> 📧 Email:{' '}
        <Link href="mailto:sundesh@kaliyugai.com" color="secondary">
          sundesh@kaliyugai.com
        </Link>
      </Typography>

      {/* General Inquiries */}
      <Typography variant="h2" gutterBottom sx={{ marginTop: '100px' }}>
        General Inquiries
      </Typography>
      <Typography variant="homePageBody" paragraph>
        For general questions about{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, our
        products, or our mission:
        <br />
        📧 Email:{' '}
        <Link href="mailto:support@kaliyugai.com" color="secondary">
          support@kaliyugai.com
        </Link>
      </Typography>

      {/* Support Box */}
      <Typography variant="h2" gutterBottom sx={{ marginTop: '100px' }}>
        Support
      </Typography>
      <StyledPaper variant="outlined">
        <Typography variant="homePageBody" align="center">
          Need help or have an issue with one of our services?
          <br />
          Email:{' '}
          <Link href="mailto:support@kaliyugai.com" color="secondary">
            support@kaliyugai.com
          </Link>
        </Typography>
      </StyledPaper>

      {/* FAQ Section */}
      <YellowBoxBottom>
        <Typography variant="h2" gutterBottom fontWeight={600}>
          FAQs
        </Typography>
        <Typography variant="homePageBody">
          Have questions?
          <br />
          Visit our{' '}
          <Link
            href="/what-to-ask"
            rel="noopener noreferrer"
            underline="hover"
            color="secondary"
            sx={{ display: 'inline-flex', alignItems: 'center' }}
          >
            FAQ page <OpenInNewIcon sx={{ fontSize: 16, ml: 0.5 }} />
          </Link>{' '}
          for quick answers to common inquiries.
        </Typography>
      </YellowBoxBottom>
    </Box>
  );
};

export default ContactSection;
